import React from "react";

import { useQueryState, useQueryStateLazy } from "../../../components/src/use-query-state";
import { DateHelper } from "../../../common/src";

interface PeriodSelectorProps {
    firstAvailableStartDate: string;
    endDate?: string;
    /** When true, do not write defaults to URL until user picks a period */
    lazyUrl?: boolean;
}

export const PeriodSelector = ({ firstAvailableStartDate, endDate, lazyUrl = false }: PeriodSelectorProps): React.ReactElement => {
    const yesterday: string = DateHelper.dateToString(DateHelper.dateAddDays(new Date(), -1));
    const useHook = lazyUrl ? useQueryStateLazy : useQueryState;

    const [_startDate, _setStartDate] = useHook("startDate", "2020-01-01");
    const [_endDate] = useHook("endDate", endDate ?? yesterday);

    return (
        <div className="flex flex-wrap  mb-3">
            <div
                className="m-2 p-1 hover__pointer"
                style={{ width: "auto", height: "auto" }}
                onClick={() => {
                    _setStartDate(DateHelper.addDays(_endDate, -7));
                }}
            >
                Week
            </div>
            <div
                className="m-2 p-1 hover__pointer"
                style={{ width: "auto", height: "auto" }}
                onClick={() => {
                    _setStartDate(DateHelper.addMonths(_endDate, -1));
                }}
            >
                Month
            </div>
            <div
                className="m-2 p-1 hover__pointer"
                style={{ width: "auto", height: "auto" }}
                onClick={() => {
                    const previousYear = DateHelper.getYear(_endDate) - 1;
                    _setStartDate(previousYear + "-12-31");
                }}
            >
                Ytd
            </div>
            <div
                className="m-2 p-1 hover__pointer"
                style={{ width: "auto", height: "auto" }}
                onClick={() => {
                    _setStartDate(DateHelper.addYears(_endDate, -1));
                }}
            >
                Year
            </div>
            <div
                className="m-2 p-1 hover__pointer"
                style={{ width: "auto", height: "auto" }}
                onClick={() => {
                    _setStartDate(DateHelper.addYears(_endDate, -5));
                }}
            >
                {"5years"}
            </div>
            <div
                className="m-2 p-1 hover__pointer"
                style={{ width: "auto", height: "auto" }}
                onClick={() => {
                    _setStartDate(firstAvailableStartDate);
                }}
            >
                All
            </div>
        </div>
    );
};
